import * as React from "react";
const IconGrid2Plus = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M21.7 4.7H9c-2.8 0-5 2.2-5 5v12.7c0 2.8 2.2 5 5 5h12.7c2.8 0 5-2.2 5-5V9.7c0-2.8-2.2-5-5-5m3 17.7c0 1.7-1.3 3-3 3H9c-1.7 0-3-1.3-3-3V9.7c0-1.7 1.3-3 3-3h12.7c1.7 0 3 1.3 3 3zM55 4.7H42.3c-2.8 0-5 2.2-5 5v12.7c0 2.8 2.2 5 5 5H55c2.8 0 5-2.2 5-5V9.7c0-2.8-2.2-5-5-5m3 17.7c0 1.7-1.3 3-3 3H42.3c-1.7 0-3-1.3-3-3V9.7c0-1.7 1.3-3 3-3H55c1.7 0 3 1.3 3 3zM21.7 36.6H9c-2.8 0-5 2.2-5 5v12.7c0 2.8 2.2 5 5 5h12.7c2.8 0 5-2.2 5-5V41.6c0-2.8-2.2-5-5-5m3 17.7c0 1.7-1.3 3-3 3H9c-1.7 0-3-1.3-3-3V41.6c0-1.7 1.3-3 3-3h12.7c1.7 0 3 1.3 3 3zM58.4 46h-8.9v-8.9c0-.6-.4-1-1-1s-1 .4-1 1V46h-8.9c-.6 0-1 .4-1 1s.4 1 1 1h8.9v8.9c0 .6.4 1 1 1s1-.4 1-1V48h8.9c.6 0 1-.4 1-1s-.5-1-1-1" />
  </svg>
);
export default IconGrid2Plus;
